export default {
  required: 'Ce champ est obligatoire',
  email: 'Adresse e-mail incorrecte',
  emailLength: 'L\'adresse mail ne doit pas faire plus de 180 caractères',
  firstNameLength: 'Ce champ doit contenir entre 1 et 100 caractères',
  insee: 'Le code INSEE doit être un code alphanumérique de 5 caractères',
  ins: 'Numéro invalide',
  oid: 'OID invalide',
  phone: 'Numéro de téléphone incorrect'
}
